export const _LOAD_MODEL_ = 'Load:ProductModel';
export const _DELETE_PRODUCT_ = 'Delete:Product';
export const _SAVE_PRODUCT_SUCCESS_ = 'Save:ProductSuccess';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _OPEN_CONFIRMATION_ = 'Confirmation:Open';

export const OPTIONS_CONFIRMATION_MODAL = {
  product: {
    callback: 'deleteRow',
    title: 'Confirme exclusão de produto',
    message: 'Tem certeza que deseja excluir esse produto?',
  },
  file: {
    callback: 'deleteFile',
    title: 'Confirme deletar arquivo',
    message: 'Tem certeza que deseja deletar este arquivo?',
  },
};

export const MODEL_TYPE_OPTION = {
  id: null,
  name: null,
};

export const MODEL_IMAGE = {
  id: null,
  url: null,
  name: null,
  uuid: null,
  type: null,
  size: null,
  url_image: null,
};

export const MODEL = {
  id: null,
  name: '',
  slug: '',
  audio: null,
  voice: 'Ricardo',
  status: 'draft',
  images: [],
  is_new: 0,
  show_player: 1,
  excerpt: '',
  description: '',
  product_url: '',
  views: null,
};
